import React from 'react';
import PropTypes from 'prop-types';
import {LogEvent} from '@learningblocks/shared-components';
import {Button} from '@learningblocks/shared-components';
import {scrollToSectionTop} from '@learningblocks/protocol-constants/lib/Utilities';
import './style.scss';

const CONTENT_SECTION_SELECTOR = 'div.notebook-content__body';
const USE_REPORT_READOUT = false;

export class ContentFooter extends React.Component {
  goToNextSection = () => {
    scrollToSectionTop(CONTENT_SECTION_SELECTOR);
    this.props.toNextSection(this.props.nextSection.value);
  };

  endSimulation = () => {
    this.props.setModal({
      display: false,
      type: "END_SIMULATION",
      size: 'sm',
      connect: -1
    })
    this.props.showModal({
      display: true
    })
  };

  nextSectionButton() {
    return (
      <LogEvent
        logEventProps={{
          event_type: `sim_${this.props.currentSection.value.toLowerCase()}_nextsection_btn clicked`,
          event_schema: "track"
        }}
        actionProps={{ onClick: { action: 'click' } }}
        elementType="button"
      >
        <Button className='nextSection' onClick={this.goToNextSection} ariaLabel="Next section">
          Next section
        </Button>
      </LogEvent>
    );
  }
  endSimulationButton(){
    return (
      <div className="report-footer">
        <p>You have completed this simulation.</p>
        <Button className='endSimulation' onClick={this.endSimulation}>
          End simulation
        </Button>
      </div>
    );
  };
  simulationReportOut(){
    return (
      <div className="report-footer">
        <p>You have completed this simulation.</p>
        <Button className='endSimulation' onClick={this.endSimulation}>
          Finish simulation
        </Button>
      </div>
    )
  };

  render() {
    return (
      <div className='notebook-content__footer' style={{background: '#CCD8E1'}}>
      {
        (this.props.nextSection)?
          this.nextSectionButton():
          (!USE_REPORT_READOUT)?
            this.endSimulationButton():
            this.simulationReportOut()
      }
      </div>
    );
  }
}

ContentFooter.propTypes = {
  nextSection: PropTypes.object,
  toNextSection: PropTypes.func,
};
